import { ApiError } from '../../lib/api';

/** Mensajes para el usuario según el `code` de qr-api; siempre dicen qué pasó y qué hacer. */
const CODE_MESSAGES: Record<string, string> = {
  destination_invalid: 'La dirección no es válida. Usa una URL completa que empiece con https://.',
  invalid_url: 'La dirección no es válida. Usa una URL completa que empiece con https://.',
  destination_flagged: 'Ese destino está marcado como peligroso (phishing o malware). Usa otro enlace; el destino anterior se mantiene.',
  already_activated: 'Alguien activó este QR recién. Recarga para ver sus datos.',
  pii_field_not_allowed: 'No guardamos RUT, email ni teléfono del negocio. Quita esos datos e intenta de nuevo.',
  quantity_out_of_range: 'La cantidad debe estar entre 1 y 5.000. No se reservó ningún código.',
  no_codes_available: 'No quedan códigos disponibles en este dominio. Escríbenos para ampliar el stock.',
  invalid_style: 'El estilo tiene valores que no reconocemos. Vuelve a elegir un preset.',
  style_rejected: 'El estilo no cumple las reglas de lectura. Revisa los avisos del paso Estilo.',
  invalid_logo: 'No encontramos el logo. Súbelo de nuevo.',
  invalid_upload: 'El archivo no se pudo leer. Sube un PNG o JPG de hasta 2 MB.',
  logo_too_large: 'El logo pesa más de 2 MB. Sube una versión más liviana.',
  unsupported_media_type: 'Formato no soportado. Sube un PNG o JPG.',
  unsafe_svg: 'Ese SVG trae contenido que no permitimos. Súbelo como PNG.',
  ambiguous_reference: 'Esa referencia corresponde a más de un QR. Edita por código.',
  invalid_transition: 'El QR ya no está en un estado que permita este cambio. Recarga la ficha.',
  reason_required: 'Indica un motivo.',
  domain_not_allowed: 'Tu organización no puede emitir en ese dominio.',
  invalid_distance: 'La distancia de lectura tiene que ser mayor que cero.',
  not_scannable: 'Esa versión no escanea: no puede ser la principal. Elige otra o el QR clásico de respaldo.',
  last_usable: 'No puedes retirar la última versión utilizable: el código siempre tiene que tener una.',
  already_retired: 'Esa versión ya estaba retirada.',
  not_art: 'Este código no es QR Art: solo tiene su versión clásica.',
  prompt_required: 'Escribe el prompt de la versión nueva.',
  reason_too_short: 'El motivo tiene que tener al menos 10 caracteres.',
};

export function describeApiError(err: unknown, fallback = 'No pudimos completar la acción. Intenta de nuevo.'): string {
  if (err instanceof ApiError) {
    if (err.code && CODE_MESSAGES[err.code]) return CODE_MESSAGES[err.code];
    switch (err.kind) {
      case 'network':
        return err.message;
      case 'forbidden':
        return 'Tu rol no tiene permiso para esta acción.';
      case 'not_found':
        return 'No encontramos ese recurso en tu organización.';
      case 'rate_limited':
        return `Demasiadas solicitudes seguidas. Espera ${err.retryAfterSeconds ?? 30} s e intenta de nuevo.`;
      case 'conflict':
        return err.message || 'Otro cambio llegó antes. Recarga e intenta de nuevo.';
      case 'validation':
        return err.message || fallback;
      default:
        return err.correlationId ? `${fallback} (referencia ${err.correlationId})` : fallback;
    }
  }
  return fallback;
}

export function errorCode(err: unknown): string | undefined {
  return err instanceof ApiError ? err.code : undefined;
}
